import { useSite } from "./use-site";
export var usePlatformUrl = function usePlatformUrl() {
  var site = useSite();

  if (site && site.platformUrl) {
    return process.env.PLATFORM_URL || site.platformUrl;
  }

  return process.env.PLATFORM_URL || '';
};